window.ondragover = function (e) { e.preventDefault(); return false }
window.ondrop = function (e) { e.preventDefault(); return false }

export const BASE_API_URL: string = window.isDevBuild ? 'https://constructor.tippo.ru' : ''

import './web-components/layouts-upload-modal'
import './web-components/upload-zone'
import './web-components/layout-errors-modal'
import './web-components/layouts-viewer'

const font = document.createElement("link")
font.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500&family=Manrope:wght@200;300;400;500;600;700;800&display=swap"
font.rel = "stylesheet"
document.head.append(font)